var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruckInfoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.667 36H69V22.667A2.667 2.667 0 0066.333 20H7.667A2.667 2.667 0 005 22.667v48a2.667 2.667 0 002.667 2.666h2.666v-48h53.334v31.2a17.199 17.199 0 014.16-.533H69V41.333h10.667A5.333 5.333 0 0185 46.667v2.666H74.333v5.334H85V68h-6.4a12.106 12.106 0 00-22.24 0H38.147a12 12 0 00-11.12-7.36A11.68 11.68 0 1038.92 73.333h16.747a11.973 11.973 0 0023.786 0h8.214a2.667 2.667 0 002.666-2.666v-24A10.667 10.667 0 0079.667 36zm-52.64 42.667a6.348 6.348 0 01-2.552-12.308A6.346 6.346 0 0127.027 66a6.346 6.346 0 110 12.667zm40.453 0a6.347 6.347 0 116.667-6.32 6.507 6.507 0 01-6.667 6.32z",
    fill: "#fff"
  })));
}

export default SvgTruckInfoWhite;